import { ModalsStyleTokens } from "./modals.tokens";

export const ModalsStyles: ModalsStyleTokens = {
    confirmButton: {
        color: "success"
    }
};
